import FileManagerPanel from '@/components/FileManagerPanel'

export default function AssetsPage() {
  return (
    <div className="p-6 flex flex-col h-full">
      <div className="mb-4">
        <h1 className="text-lg font-semibold text-white">Assets Management</h1>
      </div>
      <div className="flex-1 min-h-0">
        <FileManagerPanel mode="page" />
      </div>
    </div>
  )
}
